import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LowLevelApi } from '@app/shared/services/state/low-level-api.service';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CommonErrorInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private llapi = inject(LowLevelApi);


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (!request.url.includes('/auth/login') && err && (err.status === 401)) {
              // unauth
              this.llapi.patchValue('auth.authenticated', false);
              this.router.navigate(['/login']);
              return EMPTY;
            }
            return throwError(err);
          } else {
            return throwError(err);
          }
        })
      );
  }
}
